export default __webpack_public_path__ + "static/media/Banana Milkshake - proportioned_170.062c0d3c.png";